
import { mapState } from 'vuex'
import LoleBtn from '~/components/buttons/lole-btn.vue'
import LoleGoogleMaps from '~/components/google-maps/lole-google-maps.vue'
import generateHeader from '~/helpers/header'
import SvgFlagUs from '~/assets/icons/flag-us.svg?inline'
import SvgFlagCa from '~/assets/icons/flag-ca.svg?inline'
export default {
  name: 'StoreLocator',
  components: {
    LoleBtn,
    LoleGoogleMaps,
    SvgFlagUs,
    SvgFlagCa,
  },
  async asyncData({ error, app: { $storyblok, $sentryException, $gtm } }) {
    let pageInfo, wording
    const storesId = []
    try {
      pageInfo = await $storyblok.getStory(`/pages/store_locator_page`)
      wording = pageInfo.story.content
      if (pageInfo.story.content.stores) {
        pageInfo.story.content.stores.forEach((store) => {
          storesId.push(store.placeId)
        })
      }
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok store_locator_page failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok store_locator_page failed',
      })
    }
    try {
      $gtm.push({
        ecommerce: undefined,
        product: undefined,
        search: undefined,
      })
      $gtm.push({ 'page.type': 'static' })
    } catch (e) {
      $sentryException(e, {
        source: 'GTM page store locator',
        level: 'warning',
        extra: 'GTM page store locator failed',
      })
    }
    return { wording, storesId }
  },
  data: () => ({
    wording: null,
    storesId: null,
    store_toShow: 0,
  }),
  head() {
    if (!this.wording.seo) return
    this.wording.seo.og_image = this.wording.seo.og_image
      ? this.wording.seo.og_image
      : this.$config.DEFAULT_OG_IMAGE

    return generateHeader({
      ...this.wording.seo,
      path: this.$route.path,
    })
  },
  computed: {
    ...mapState({
      stores: (state) => state.stores.storesList,
    }),
  },
  mounted() {
    this.initStores(this.storesId)
  },
  methods: {
    async initStores(ids) {
      await this.$store.dispatch('stores/getPlacesDetailsByPlaceIds', ids)
    },
    selectStore(id) {
      this.stores.forEach((store, index) => {
        if (store.place_id === id) this.store_toShow = index
      })
    },
    getNameByStoryblok(store) {
      let name = null
      this.wording.stores.forEach((store_item) => {
        if (store_item.placeId === store.place_id) {
          name = store_item.overwrite_title
        }
      })
      return name || store.name
    },
  },
}
